import { AfterViewInit, Component, HostListener, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { AuthState, BranchChange, Logout } from '@beautyapp/auth';
import { Observable, Subject } from 'rxjs';
import { Branch, BranchService, ChangeLanguage, ResizeService } from '@beautyapp/core';
import { NavigationItem } from '../common/navigation';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { takeUntil, tap } from 'rxjs/operators';
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { RouterModule } from "@angular/router";
import { NzLayoutModule } from "ng-zorro-antd/layout";
import { NzMenuModule } from "ng-zorro-antd/menu";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzSelectModule } from "ng-zorro-antd/select";
import { FormsModule } from "@angular/forms";
import { NzGridModule } from "ng-zorro-antd/grid";
import { AppointmentSearchComponent } from "@beautyapp/appointment";

@Component({
    selector: 'beautyapp-main-mobile',
    templateUrl: './main-mobile.component.html',
    styleUrls: ['./main-mobile.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        TranslateModule,
        NgxPermissionsModule,
        NzLayoutModule,
        NzMenuModule,
        NzIconModule,
        NzButtonModule,
        NzDropDownModule,
        NzSelectModule,
        NzGridModule,
        AppointmentSearchComponent
    ]
})
export class MainMobileComponent implements OnInit, OnDestroy, AfterViewInit {

  private store: Store = inject(Store);
  private branchService: BranchService = inject(BranchService);
  private translateService: TranslateService = inject(TranslateService);
  private resizeSvc: ResizeService = inject(ResizeService);

  selectedBranch$ = this.store.select(AuthState.getActiveBranch);


  @Input() navigation: NavigationItem[] = [];
  branches$!: Observable<Branch[]>;
  selectedBranch!: Branch;
  isCollapsed = true;
  sub$: Subject<any> = new Subject<any>();

  size = 0;
  lang: any = 'ka';

  constructor() {
    this.lang = this.translateService.currentLang;
  }

  ngOnInit(): void {
    this.getBranches();
    this.selectedBranch$.pipe(takeUntil(this.sub$)).subscribe((res) => {
      if (res) {
        this.selectedBranch = res;
      }
    });
  }

  @HostListener('window:resize', [])
  private onResize() {
    this.detectScreenSize();
  }

  ngAfterViewInit() {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    this.resizeSvc.init();
    this.resizeSvc.mediaBreakpoint$.pipe(
      tap((r) => {
        this.size = r;
        if (r === 0) {
          this.isCollapsed = true;
        }
      })
    );
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  getBranches() {
    this.branches$ = this.branchService.getMyBranches();
  }

  setBranch(branch: any) {
    this.selectedBranch = branch;
    this.store.dispatch(new BranchChange(branch));
  }

  ngOnDestroy(): void {
    this.sub$.next(null);
    this.sub$.complete();
  }

  langChange(lang: 'en' | 'ru' | 'ka') {
    this.store.dispatch(new ChangeLanguage(lang))
      .pipe()
      .subscribe(() => {
        window.location.reload();
      });
  }
}
